import { Component } from '@angular/core';

@Component({
	selector: 'app-archived-badge',
	templateUrl: './archived-badge.component.html',
	styleUrl: './archived-badge.component.scss',
})
export class ArchivedBadgeComponent {}
